// DEV server environment — served at inventory-dev.childcarewow.app behind nginx-proxy-manager.
// Build with: --configuration devserver (Docker: --build-arg BUILD_CONFIGURATION=devserver).
// Auth uses the DEV Keycloak 'wowcare' realm (auth-dev, served under /auth-service);
// Firebase project: wow-inventory.
export const environment = {
    production: false,
    serviceUrl: 'https://inventory-dev.childcarewow.app/api',
    useHash: false,
    configFile: 'assets/layout/config/config.qa.json',
    path: '/',
    apiUrl: 'https://inventory-dev.childcarewow.app/web-api',
    clientId: 'wow_inventory_backend',
    authentication: 'https://auth-dev.childcarewow.app/auth-service/realms/wowcare/protocol/openid-connect/token',
    firebase: {
        apiKey: "AIzaSyCubltupbbPWw2L80GXO0NgI40AqslrerM",
        authDomain: "wow-inventory.firebaseapp.com",
        databaseURL: "https://wow-inventory-default-rtdb.firebaseio.com",
        projectId: "wow-inventory",
        storageBucket: "wow-inventory.firebasestorage.app",
        messagingSenderId: "252662395700",
        appId: "1:252662395700:web:f858b9d8b8b28ae33dab61",
        measurementId: "G-TZKEE3W3QV",
        vapidKey: "BISMl98ci_pFT2V1MQ0_1H6pshcsRwFxeuTtXWjJY7x4AvGLpccU2oiCdjPr_mhXXp1NDuL05lC6wCwcglAXfgQ"
    }
};
